import { useEffect, useState } from 'react'
import Cookie from 'cookie-universal'
import { ONE_WEEK } from '@mc/constants'

const COOKIE_KEY = 'pen-5950_v1_badge_dismissed'

export const useBadgeVisibility = () => {
  const [showBadge, setShowBadge] = useState(false)

  useEffect(() => {
    const cookies = Cookie()
    const isDismissed = cookies.get(COOKIE_KEY)
    setShowBadge(!isDismissed)
  }, [])

  const dismissBadge = () => {
    setShowBadge(false)
    const cookies = Cookie()
    cookies.set(COOKIE_KEY, 'true', { maxAge: ONE_WEEK })
  }

  return {
    showBadge,
    dismissBadge,
  }
}
